import { render, staticRenderFns } from "./SidebarMain.vue?vue&type=template&id=3cfc879d&scoped=true"
import script from "./SidebarMain.vue?vue&type=script&lang=js"
export * from "./SidebarMain.vue?vue&type=script&lang=js"
import style0 from "./SidebarMain.vue?vue&type=style&index=0&id=3cfc879d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc879d",
  null
  
)

export default component.exports